import { apiFetch } from './apiClient';



export const listarEtapasObrigacao = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.obrigacaoId) qs.set('obrigacao_id', params.obrigacaoId);
  const s = qs.toString();
  return apiFetch(`/etapas-obrigacao${s ? `?${s}` : ''}`);
};

export const criarEtapaObrigacao = (dados) =>
  apiFetch('/etapas-obrigacao', { method: 'POST', body: JSON.stringify(dados) });

export const atualizarEtapaObrigacao = (id, dados) =>
  apiFetch(`/etapas-obrigacao/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });

export const excluirEtapaObrigacao = (id) =>
  apiFetch(`/etapas-obrigacao/${id}`, { method: 'DELETE' });

export const listarConclusoesEtapas = (clienteNiboId, competencia) =>
  apiFetch(`/etapas-obrigacao/conclusoes?cliente_nibo_id=${encodeURIComponent(clienteNiboId)}&competencia=${encodeURIComponent(competencia)}`);

/* sem cliente_nibo_id -- de todo mundo naquela competência, pra gatear a
   lista do Calendário/Auditoria (obrigação concluída na Nibo mas com etapa
   ainda incompleta continua contando como pendente aqui). */
export const listarConclusoesEtapasPorCompetencia = (competencia) =>
  apiFetch(`/etapas-obrigacao/conclusoes?competencia=${encodeURIComponent(competencia)}`);

export const alternarConclusaoSubitem = (etapaPadraoId, subitemId, clienteNiboId, competencia, concluido) =>
  apiFetch('/etapas-obrigacao/conclusoes', {
    method: 'PATCH',
    body: JSON.stringify({
      etapa_padrao_id: etapaPadraoId, subitem_id: subitemId,
      cliente_nibo_id: clienteNiboId, competencia, concluido,
    }),
  });
